const sms = {
  content: "SMS content",
  sendTime: "Send time",
  result: "Result",
  searchLabelWidth: '70px'
} 
export default sms